/* eslint-disable no-console */
/* eslint no-underscore-dangle: ["error", { "allow": ["__typename"] }] */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// graphQL
import gql from 'graphql-tag';
// global variables
import { paidAdStatus } from 'config';
// our components
import MultiSelect from 'components/common/MultiSelect';
import { Query } from 'components/common/Query';

const defaultFilters = {
  status: [
    paidAdStatus.PENDING,
    paidAdStatus.SCHEDULED,
    paidAdStatus.RUNNING,
    paidAdStatus.PAUSED,
  ],
  owner: undefined,
  schedule: undefined,
  frequency: undefined,
  duration: undefined,
  startDateGte: undefined,
  startDateLte: undefined,
  hasPromotion: false,
  ad: undefined,
};

/**
 * Query to fetch ads from api
 */
export const PAIDADS_QUERY = gql`
  query PaidAdsList(
    $ad: ID
    $status: [FilterAutoPaidAdStatus]
    $owner: ID
    $schedule: [FilterAutoPaidAdSchedule]
    $frequency: [RelativeDateTimeInput]
    $duration: [RelativeDateTimeInput]
    $startDateGte: DateTime
    $startDateLte: DateTime
    $hasPromotion: Boolean
  ) {
    paidAds(
      ad: $ad
      status: $status
      owner: $owner
      schedule: $schedule
      frequency: $frequency
      duration: $duration
      startDateGte: $startDateGte
      startDateLte: $startDateLte
      hasPromotion: $hasPromotion
    ) {
      edges {
        node {
          id
          owner {
            id
            fullname
          }
          ad {
            id
            title
          }
        }
      }
    }
  }
`;

class AdsSelectContainer extends Component {
  /**
   * @description
   * Query helpful function to update query's result.
   *
   * @param {Object} previousResult - Latest Query result.
   * @param {Object} options - UpdateQuery options.
   * @returns {Object} New or Previous query's result.
   */
  updateQuery = (previousResult, options) => {
    const { pageInfo, edges: newEdges } = options.fetchMoreResult.paidAds;
    return {
      paidAds: {
        __typename: previousResult.paidAds.__typename,
        edges: [...newEdges],
        pageInfo,
      },
    };
  };

  /**
   * @description
   * Fetch more paidads according to textToFind.
   *
   * @param {string} adId - Text to filter paidads.
   * @param {*} fetchMore - Query callback to pagination.
   */
  handleSearchPaidAds = (adId, fetchMore) => {
    fetchMore({
      variables: { ad: adId !== '' ? adId : undefined },
      updateQuery: this.updateQuery,
    });
  };

  render() {
    const {
      selectedAds,
      adsUpdate,
      multiSelectItemRender,
      customFilters,
    } = this.props;

    const { __typename: typename, ...frequency } = customFilters.frequency;
    const { __typename: typename1, ...duration } = customFilters.duration;

    return (
      <Query
        query={PAIDADS_QUERY}
        variables={{
          ...defaultFilters,
          ...customFilters,
          frequency: [frequency],
          duration: [duration],
        }}
        fetchPolicy="cache-and-network"
        notifyOnNetworkStatusChange
      >
        {({ data, loading, fetchMore }) => {
          if (data && Object.keys(data).length > 0) {
            return (
              <MultiSelect
                items={data.paidAds}
                selectedItems={selectedAds}
                loading={loading}
                translatePrefix="paidad"
                updateItem={adsUpdate}
                searchItem={adId => {
                  this.handleSearchPaidAds(adId, fetchMore);
                }}
                itemRender={multiSelectItemRender}
              />
            );
          }
          return null;
        }}
      </Query>
    );
  }
}

/**
 * AdsSelectContainer PropTypes
 * @param customFilters - prop to know custom filters
 * @param selectedAds - prop added permissions pass to PermissionSelect
 * @callback adsUpdate - callback function pass to PermissionSelect
 */

AdsSelectContainer.propTypes = {
  customFilters: PropTypes.instanceOf(Object).isRequired,
  selectedAds: PropTypes.instanceOf(Array).isRequired,
  adsUpdate: PropTypes.func.isRequired,
  multiSelectItemRender: PropTypes.func.isRequired,
};

export default AdsSelectContainer;
